module.exports = "/_next/static/images/bocongthuong-6f134a867c66d73dbdcf8a813aec53d3.png.webp";